
import { Download, Features, SectionWrapper } from './components';
import assets from './assets';

const App = () => {
  return (
    <>
      <SectionWrapper 
        title="Selfman - Your own store to publish Images and Notes"
        description="Store, share and manage your images and notes in one place."
        showBtn
        mockupImg={assets.project}
        banner="banner"
      />
    
      <Features />
   
      <Download />


    </>
  );
}

export default App;
